module.exports = __webpack_public_path__ + "media/images/pla/pla16-37f398349a0a710ac49be96084e54ae5.jpg";